(() => {
  const root = document.querySelector('[data-bra-cart]');
  const form = root?.querySelector('[data-cart-form]');
  if (!form) return;
  root.classList.add('is-enhanced');
  const error = root.querySelector('[data-cart-error]');
  let updating = false;
  const scrollKey = 'lumora-cart-scroll';
  const upsellSelectors = [...root.querySelectorAll('[data-upsell-variant]')];
  const upsellButton = root.querySelector('[data-upsell-add]');
  let bundleConfig = { tiers: {}, codes: {} };
  const configReady = (async () => {
    if (!root.dataset.upsellProductUrl) return;
    if (upsellButton) upsellButton.disabled = true;
    const response = await fetch(root.dataset.upsellProductUrl);
    if (!response.ok) throw new Error('Unable to load bundle offers. Please refresh and try again.');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const configNode = doc.querySelector('[data-mxfs-bundle-config]');
    if (!configNode) throw new Error('Bundle offers are unavailable. Please choose your bundle on the product page.');
    bundleConfig = JSON.parse(configNode.textContent);
    updateUpsellPrice();
    if (upsellButton) upsellButton.disabled = false;
  })();
  configReady.catch(failure => {
    error.textContent = failure.message;
    error.hidden = false;
  });
  async function normalizeBundleItems(state) {
    await configReady;
    const tiers = Object.entries(bundleConfig.tiers).filter(([, discount]) => Number(discount) > 0)
      .sort((a, b) => Number(a[0]) - Number(b[0])).map(([quantity, discount]) => quantity + ':' + discount).join('|');
    if (!tiers) return state;
    const codes = JSON.stringify(bundleConfig.codes);
    const fixedTotals = JSON.stringify(bundleConfig.fixedTotals || {});
    for (let attempt = 0; attempt < 100; attempt++) {
      const item = state.items.find(item => String(item.product_id) === root.dataset.bundleProductId &&
        (item.properties?._MxBundleTiers !== tiers || item.properties?._MxBundleCodes !== codes || item.properties?._MxBundleFixedTotals !== fixedTotals || item.properties?._MxBundleThreeTotal !== String(bundleConfig.fixedTotals?.[3] || 0)));
      if (!item) return state;
      const properties = { ...item.properties, _MxBundleThreeTotal: String(bundleConfig.fixedTotals?.[3] || 0), _MxBundleTiers: tiers, _MxBundleCodes: codes, _MxBundleFixedTotals: fixedTotals };
      const response = await fetch(root.dataset.cartUrl + '/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: item.quantity, properties })
      });
      if (!response.ok) throw new Error('Unable to synchronize the bundle offer. Please try again.');
      state = await response.json();
    }
    throw new Error('Unable to synchronize the bundle offer. Please refresh the cart.');
  }
  async function syncBundleCodes(state) {
    const groups = new Map();
    const knownCodes = new Set();
    for (const item of state.items) {
      const props = item.properties || {};
      if (!props._MxBundleTiers) continue;
      let codes = {};
      try { codes = JSON.parse(props._MxBundleCodes || '{}'); } catch (_) {}
      Object.values(codes).forEach(code => { if (String(code || '').trim()) knownCodes.add(String(code).trim()); });
      const key = item.product_id + ':' + props._MxBundleTiers;
      const group = groups.get(key) || { quantity: 0, tiers: props._MxBundleTiers, codes };
      group.quantity += item.quantity;
      groups.set(key, group);
    }
    const desired = new Set();
    for (const group of groups.values()) {
      const eligible = group.tiers.split('|').map(tier => tier.split(':').map(Number))
        .filter(([quantity, discount]) => quantity > 0 && discount > 0 && quantity <= group.quantity)
        .sort((a, b) => b[0] - a[0]);
      const code = eligible.length ? String(group.codes[eligible[0][0]] || '').trim() : '';
      if (code) desired.add(code);
    }
    const previous = String(state.attributes?._MxAppliedBundleCodes || '').split(',').filter(Boolean);
    if (!knownCodes.size && !previous.length) return state;
    previous.forEach(code => knownCodes.add(code));
    const desiredList = [...desired].sort();
    if (desiredList.join(',') === previous.sort().join(',')) return state;
    const otherCodes = (state.cart_level_discount_applications || [])
      .filter(discount => discount.type === 'discount_code' && !knownCodes.has(discount.title))
      .map(discount => discount.title);
    const response = await fetch(root.dataset.cartUrl + '/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: [...otherCodes, ...desiredList].join(','), attributes: { _MxAppliedBundleCodes: desiredList.join(',') } })
    });
    if (!response.ok) throw new Error('Unable to update the bundle discount. Please try again.');
    return response.json();
  }
  const formatMoney = amount => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  }).format(amount / 100);
  function updateUpsellPrice() {
    const choices = upsellSelectors.map(select => select.selectedOptions[0]);
    const base = choices.reduce((sum, option) => sum + Number(option.dataset.price), 0);
    const total = Math.round(base * (100 - Number(bundleConfig.tiers[2] || 0)) / 100);
    const compare = choices.reduce((sum, option) => sum + Math.max(Number(option.dataset.price), Number(option.dataset.compare)), 0);
    const price = root.querySelector('[data-upsell-price]');
    if (!price) return;
    price.textContent = formatMoney(total);
    if (compare > total) {
      const strike = document.createElement('s');
      strike.textContent = formatMoney(compare);
      price.append(' ', strike);
    }
  }
  upsellSelectors.forEach(select => select.addEventListener('change', updateUpsellPrice));
  if (upsellButton) upsellButton.addEventListener('click', async () => {
    if (updating) return;
    updating = true;
    upsellButton.disabled = true;
    upsellButton.textContent = 'Adding...';
    error.hidden = true;
    try {
      await configReady;
      const tiers = Object.entries(bundleConfig.tiers).filter(([, discount]) => Number(discount) > 0).sort((a, b) => Number(a[0]) - Number(b[0])).map(([quantity, discount]) => quantity + ':' + discount).join('|');
      const discount = Number(bundleConfig.tiers[2] || 0);
      const properties = { 'Bundle Deal': 'Buy 2' + (discount ? ', Save ' + discount + '% OFF' : ''), _MxBundleQty: '2', _MxBundleDiscount: String(discount), _MxBundleTiers: tiers, _MxBundleCodes: JSON.stringify(bundleConfig.codes), _MxBundleFixedTotals: JSON.stringify(bundleConfig.fixedTotals || {}) };
      const items = [];
      upsellSelectors.forEach(select => {
        const existing = items.find(item => item.id === Number(select.value));
        if (existing) existing.quantity += 1;
        else items.push({ id: Number(select.value), quantity: 1, properties });
      });
      const response = await fetch(root.dataset.cartUrl + '/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this bundle. Please try again.');
      await syncBundleCodes(await normalizeBundleItems(await (await fetch(root.dataset.cartUrl + '.js')).json()));
      try { sessionStorage.setItem(scrollKey, String(window.scrollY)); } catch (_) {}
      window.location.reload();
    } catch (failure) {
      updating = false;
      upsellButton.disabled = false;
      upsellButton.textContent = 'Add to Cart';
      error.textContent = failure.message;
      error.hidden = false;
      error.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    }
  });
  try {
    const saved = sessionStorage.getItem(scrollKey);
    if (saved !== null) {
      sessionStorage.removeItem(scrollKey);
      requestAnimationFrame(() => window.scrollTo({ top: Number(saved), behavior: 'instant' }));
    }
  } catch (_) {}

  async function updateQuantity(input) {
    const value = Number(input.value);
    if (updating || !Number.isInteger(value) || value < 0) return;
    updating = true;
    error.hidden = true;
    const oldValue = input.defaultValue;
    form.querySelectorAll('[data-quantity-step], [data-cart-quantity], [name="checkout"]').forEach(el => { el.disabled = true; });
    try {
      const response = await fetch(root.dataset.cartUrl + '/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(input.closest('[data-cart-item]').dataset.line), quantity: value })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to update your cart. Please try again.');
      await syncBundleCodes(await normalizeBundleItems(result));
      try { sessionStorage.setItem(scrollKey, String(window.scrollY)); } catch (_) {}
      window.location.reload();
    } catch (failure) {
      input.value = oldValue;
      error.textContent = failure.message;
      error.hidden = false;
      updating = false;
      form.querySelectorAll('[data-quantity-step], [data-cart-quantity], [name="checkout"]').forEach(el => { el.disabled = false; });
    }
  }
  form.addEventListener('click', event => {
    const button = event.target.closest('[data-quantity-step]');
    if (!button || updating) return;
    const input = button.parentElement.querySelector('[data-cart-quantity]');
    input.value = Math.max(0, Number(input.value) + Number(button.dataset.quantityStep));
    updateQuantity(input);
  });
  form.addEventListener('change', event => {
    if (event.target.matches('[data-cart-quantity]')) updateQuantity(event.target);
  });
  (async () => {
    const state = await (await fetch(root.dataset.cartUrl + '.js')).json();
    const normalized = await normalizeBundleItems(state);
    const synced = await syncBundleCodes(normalized);
    if (synced.total_price !== state.total_price || normalized !== state) window.location.reload();
  })().catch(failure => {
    error.textContent = failure.message;
    error.hidden = false;
  });
})();
